<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import DatePicker from '~/components/form-elements/DatePicker.vue'
import RadioButtons from '~/components/form-elements/RadioButtons.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import { useExporting } from '~/composables/exporting'
import AuthScope from '~/enums/auth-scope'
import Export from '~/enums/export'
import type { DateTimeRange } from '~/types/date-time'
import type { RadioButtonChoice } from '~/types/form-elements'

const model = defineModel<boolean>()

type Data = {
  orderCreatedAfter: string
  orderCreatedBefore: string
  step: Step
  timeZone?: string
}

type Form = {
  dateTimeRange: DateTimeRange | null
  step: Step
}

enum Step {
  Day = 'day'
}

const messages = {
  dateOrDateRangeIsNotSelected: 'Не выбрана дата или диапазон дат.'
}
const stepChoices: RadioButtonChoice[] = [{ labelText: 'По дням', value: Step.Day }]

const { $toast } = useNuxtApp()
const { exportData } = useExporting()

const form = ref<Form>({ dateTimeRange: null, step: Step.Day })
const isLoading = ref(false)

function close (): void {
  model.value = false
}

async function download (): Promise<void> {
  const { dateTimeRange, step } = form.value

  if (!dateTimeRange) {
    $toast.error(messages.dateOrDateRangeIsNotSelected)

    return
  }

  const { formattedDateTime1, formattedDateTime2, timeZone } = dateTimeRange

  const data: Data = {
    orderCreatedAfter: formattedDateTime1,
    orderCreatedBefore: formattedDateTime2,
    step,
    timeZone
  }

  isLoading.value = true

  await exportData(AuthScope.Admin, Export.OrdersStatistics, 'Статистика заказов.xlsx', data)

  isLoading.value = false
}

function setDateTimeRange (x: DateTimeRange | null): void {
  form.value.dateTimeRange = x
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Экспорт статистики заказов
    </template>

    <DatePicker class="mb-6" is-range-mode @set-date-time-range="setDateTimeRange" />

    <RadioButtons
      v-model="form.step"
      :choices="stepChoices"
      class="mb-6"
      is-vertical
      label-text="Детализация"
      name="step"
    />

    <BasicButton color="green" :is-loading="isLoading" title="Скачать таблицу (XLSX)" @click="download" />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
